import ComponentStructure from '../basic'

export default class I18nForLwBoard extends ComponentStructure {
  name = 'lw-board'
  properties = []

  getHtmlElement () {
    return null
  }

  getPropertyShownElement (property: string) {
    return null
  }

  getChildComponents () {
    return this.component.components || []
  }
}
